import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useFlightNumbersPanelStyles = makeStyles({
    root: {
        height: 'calc(100% - 50px)',
        boxSizing: 'border-box',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    table: {
        paddingTop: tokens.spacingVerticalM,
        height: 'fit-content',
        overflow: 'auto',
        flexGrow: 1,
        flexShrink: 1,
    },
    tableRow: {
        justifyContent: 'space-between',
        minWidth: 'fit-content',
        ...shorthands.padding(0, tokens.spacingHorizontalXL),
    },
    header: {
        paddingRight: 'var(--scrollbar-width, 4px)',
        height: 'var(--header-height)',
    },
    spinner: {
        position: 'absolute',
        minWidth: '100%',
        top: '50%'
    },
    messageBar: {
        padding: tokens.spacingVerticalM,
    }
});
